import React from 'react';

import { Card } from '@components/Card';

import { cnEmptyContent } from './EmptyContent.const';
import type { IEmptyContentProps } from './EmptyContent.typings';
import './EmptyContent.scss';

export const EmptyContent: React.FC<IEmptyContentProps> = props => (
    <Card className={cnEmptyContent(null, [props.className])}>{props.children}</Card>
);
